"use strict";
/**
 * Compress / encrypt / decrypt on row.edit.pnBody.
 *
 * Primary flow: OPEN → TYPE → ACT(this module).
 *   1. flushOutline  — capture text from open→type (textarea)
 *   2. transform     — encryptionService
 *   3. apply external — model + textarea + map together
 *
 * Angular-free so unit tests drive the pipeline without AudRoamCtrl.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCryptoBodyHost = exports.tryAutoDecode = exports.decryptRowContent = exports.encryptRowContent = exports.compressRowContent = exports.commitTransformedBody = exports.readBodyAfterFlush = void 0;
var editBodyAuthority_1 = require("./editBodyAuthority");
function requireEdit(row) {
    return row && row.edit ? row.edit : null;
}
/** Flush live body, then read model for transforms. */
function readBodyAfterFlush(host, row) {
    host.flushOutline(row);
    var edit = requireEdit(row);
    return edit && edit.pnBody != null ? String(edit.pnBody) : '';
}
exports.readBodyAfterFlush = readBodyAfterFlush;
/** Apply transform result with external body policy. */
function commitTransformedBody(host, row, body, state) {
    var edit = requireEdit(row);
    if (!edit)
        return;
    var plan = (0, editBodyAuthority_1.planBodyApply)('external', body, state);
    (0, editBodyAuthority_1.setEditBodyField)(edit, plan.body);
    edit.encryptionState = state;
    host.applyBodyExternal(row, plan.body);
}
exports.commitTransformedBody = commitTransformedBody;
function compressRowContent(host, row) {
    return __awaiter(this, void 0, void 0, function () {
        var edit, plain, _a, result, state, finalData, nextState, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    edit = requireEdit(row);
                    if (!edit) {
                        row.uiError = 'Open edit first';
                        return [2 /*return*/];
                    }
                    plain = readBodyAfterFlush(host, row);
                    if (!plain) {
                        row.uiError = 'Content required for compression';
                        return [2 /*return*/];
                    }
                    row.uiError = '';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, host.encryptionService.compressText(plain, edit.encryptionState)];
                case 2:
                    _a = _b.sent(), result = _a.result, state = _a.state;
                    finalData = (0, editBodyAuthority_1.formatWithPreamble)(result, edit.encryptionCaption);
                    nextState = __assign(__assign({}, state), { preamble: edit.encryptionCaption || state.preamble });
                    commitTransformedBody(host, row, finalData, nextState);
                    row.uiMessage = 'Content compressed successfully';
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error('Compression failed:', e_1);
                    row.uiError = 'Compression failed';
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.compressRowContent = compressRowContent;
function encryptRowContent(host, row) {
    return __awaiter(this, void 0, void 0, function () {
        var edit, plain, _a, result, state, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    edit = requireEdit(row);
                    if (!edit) {
                        row.uiError = 'Open edit first';
                        return [2 /*return*/];
                    }
                    plain = readBodyAfterFlush(host, row);
                    if (!edit.encryptionKey || !plain) {
                        row.uiError = 'Key and content required for encryption';
                        return [2 /*return*/];
                    }
                    row.uiError = '';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, host.encryptionService.encryptText(plain, edit.encryptionKey, true, edit.encryptionCaption || undefined, edit.encryptionState)];
                case 2:
                    _a = _b.sent(), result = _a.result, state = _a.state;
                    commitTransformedBody(host, row, result, state);
                    row.uiMessage = 'Content encrypted successfully';
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _b.sent();
                    console.error('Encryption failed:', e_2);
                    row.uiError = 'Encryption failed';
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.encryptRowContent = encryptRowContent;
function decryptRowContent(host, row) {
    return __awaiter(this, void 0, void 0, function () {
        var edit, contentToDecrypt, _a, result, state, parsed, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    edit = requireEdit(row);
                    if (!edit) {
                        row.uiError = 'Open edit first';
                        return [2 /*return*/];
                    }
                    if (!edit.encryptionKey) {
                        row.uiError = 'Encryption key required';
                        return [2 /*return*/];
                    }
                    row.uiError = '';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    contentToDecrypt = readBodyAfterFlush(host, row);
                    return [4 /*yield*/, host.encryptionService.decryptText(contentToDecrypt, edit.encryptionKey, edit.encryptionState)];
                case 2:
                    _a = _b.sent(), result = _a.result, state = _a.state;
                    commitTransformedBody(host, row, result, state);
                    parsed = host.encryptionService.parseCompressedPreamble(contentToDecrypt);
                    if (parsed) {
                        edit.encryptionCaption = parsed.preamble;
                        if (edit.encryptionState) {
                            edit.encryptionState.preamble = parsed.preamble;
                        }
                    }
                    row.uiMessage = 'Content decrypted successfully';
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _b.sent();
                    console.error('Decryption failed:', e_3);
                    row.uiError = 'Decryption failed - wrong key or not encrypted';
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.decryptRowContent = decryptRowContent;
function applyPreambleFromSource(edit, source, host) {
    var parsed = host.encryptionService.parseCompressedPreamble(source);
    if (parsed) {
        edit.encryptionCaption = parsed.preamble;
        if (edit.encryptionState) {
            edit.encryptionState.preamble = parsed.preamble;
        }
    }
}
function tryAutoDecode(host, row) {
    return __awaiter(this, void 0, void 0, function () {
        var edit, contentToProcess, _a, result, state, e_4, _b, result, state, e_5, stored, _c, result, state, e_6;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    edit = requireEdit(row);
                    if (!edit) {
                        row.uiError = 'Open edit first';
                        return [2 /*return*/];
                    }
                    contentToProcess = readBodyAfterFlush(host, row);
                    row.uiError = '';
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, host.encryptionService.decompressText(contentToProcess, edit.encryptionState)];
                case 2:
                    _a = _d.sent(), result = _a.result, state = _a.state;
                    commitTransformedBody(host, row, result, state);
                    applyPreambleFromSource(edit, contentToProcess, host);
                    row.uiMessage = 'Content decompressed successfully (keyless)';
                    return [2 /*return*/];
                case 3:
                    e_4 = _d.sent();
                    console.log('Keyless decompression failed, trying decryption:', e_4);
                    return [3 /*break*/, 4];
                case 4:
                    if (!edit.encryptionKey) return [3 /*break*/, 8];
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, host.encryptionService.decryptText(contentToProcess, edit.encryptionKey, edit.encryptionState)];
                case 6:
                    _b = _d.sent(), result = _b.result, state = _b.state;
                    commitTransformedBody(host, row, result, state);
                    applyPreambleFromSource(edit, contentToProcess, host);
                    row.uiMessage = 'Content decrypted successfully (edit key)';
                    return [2 /*return*/];
                case 7:
                    e_5 = _d.sent();
                    console.log('Decryption with user key failed:', e_5);
                    row.uiError = 'Decryption failed - check key or content not encrypted';
                    return [2 /*return*/];
                case 8:
                    stored = typeof host.encryptionService.getStoredKey === 'function'
                        ? host.encryptionService.getStoredKey()
                        : null;
                    if (!stored) return [3 /*break*/, 12];
                    _d.label = 9;
                case 9:
                    _d.trys.push([9, 11, , 12]);
                    return [4 /*yield*/, host.encryptionService.decryptText(contentToProcess, stored, edit.encryptionState)];
                case 10:
                    _c = _d.sent(), result = _c.result, state = _c.state;
                    commitTransformedBody(host, row, result, state);
                    applyPreambleFromSource(edit, contentToProcess, host);
                    row.uiMessage = 'Content decrypted successfully (stored key)';
                    return [2 /*return*/];
                case 11:
                    e_6 = _d.sent();
                    console.log('Decryption with stored key failed:', e_6);
                    return [3 /*break*/, 12];
                case 12:
                    // Soft completion: leave body unchanged (no model stomp).
                    row.uiMessage = 'Auto decode completed - content left as-is';
                    row.uiError = '';
                    return [2 /*return*/];
            }
        });
    });
}
exports.tryAutoDecode = tryAutoDecode;
/** Build a host bound to Angular-style broadcast helpers. */
function createCryptoBodyHost(encryptionService, flushOutline, applyBodyExternal) {
    return {
        encryptionService: encryptionService,
        flushOutline: flushOutline,
        applyBodyExternal: applyBodyExternal,
    };
}
exports.createCryptoBodyHost = createCryptoBodyHost;
